export default __webpack_public_path__ + "static/media/Novelties_White.312115af.svg";